// Tiny class-name combiner. Mirrors the shadcn `cn()` helper.
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...args) => twMerge(clsx(args));

const IST_FORMATTER = new Intl.DateTimeFormat('en-IN', {
  timeZone: 'Asia/Kolkata',
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
});

export const formatDate = (value) => {
  if (!value) return '-';
  let d;
  if (typeof value === 'number') {
    // If it's a timestamp in seconds (less than 10 billion), convert to ms
    const timestamp = value < 10000000000 ? value * 1000 : value;
    d = new Date(timestamp);
  } else {
    // Handle both ISO strings and "YYYY-MM-DD HH:MM:SS" from SQLite
    // Ensure we treat it as UTC by appending Z if it's not there
    let str = String(value).replace(' ', 'T');
    if (!str.includes('Z') && !str.includes('+')) {
      str += 'Z';
    }
    d = new Date(str);
  }
  if (Number.isNaN(d.getTime())) return value;
  return IST_FORMATTER.format(d);
};

export const bytesToHuman = (n) => {
  if (!n) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  const i = Math.min(units.length - 1, Math.floor(Math.log(n) / Math.log(1024)));
  return `${(n / Math.pow(1024, i)).toFixed(1)} ${units[i]}`;
};

export const detectPlatform = () => {
  const ua = navigator.userAgent || '';
  if (/Android/i.test(ua))     return 'android';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Macintosh/i.test(ua))  return 'macos';
  if (/Windows/i.test(ua))    return 'windows';
  if (/Linux/i.test(ua))      return 'linux';
  return 'web';
};
